<template>
  <el-row :gutter="20" class="panel-group">
    <el-col :span="7" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-text">
          {{ $t('dashboard.balance') }}
          <el-tooltip v-if="!checkPermission(['ROLE_AUTH_AGENT_ADMIN'])" placement="top">
            <div slot="content" style="width: 300px">
              <span>{{ $t('tips.dashboard_balance_question') }}</span>
            </div>
            <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
          </el-tooltip>
        </div>
        <div class="card-panel-num">{{ $store.getters.currency }} {{ overviewData.total_balance | toDivideWithDot }}
          <el-tooltip placement="bottom">
            <div slot="content">
              <span>{{ $t('tips.dashboard_balance_number') }} {{ overviewData.available_withdraw | toDivideWithDot }}</span>
            </div>
            <span>  <svg-icon icon-class="icon-font-warning" class="icon-warning" /></span>
          </el-tooltip>
        </div>

      </div>
    </el-col>
    <el-col :span="7" class="card-panel-col ">
      <div class="card-panel">
        <div class="card-panel-text">
          {{ $t('dashboard.in_transit') }}
        </div>
        <div class="card-panel-num">{{ $store.getters.currency }} {{ overviewData.in_transit | toDivideWithDot }}</div>
        <img class="img-bg" src="@/assets/ezpay/bg_transfer.png">
      </div>

    </el-col>
    <el-col v-if="overviewData.adb_amount" :span="7" class="card-panel-col ">
      <div class="card-panel">
        <div class="card-panel-text">
          {{ $t('dashboard.abd_balance') }}
        </div>
        <div class="card-panel-num">{{ overviewData.adb_amount | toDivideWithDot }}</div>
      </div>

    </el-col>
  </el-row>
</template>

<script>
import { fetchOverview } from '@/api/dashboard/dashboard.js'
import serviceConst from '@/const/serviceConst.json'
import { checkPermission } from '@/utils/directive/permission'
export default {
  data() {
    this.checkPermission = checkPermission
    return {
      overviewData: {
        total_balance: 0,
        in_transit: 0
      }
    }
  },
  mounted() {
    const { token } = this.$store.getters
    if (token) {
      this.getOverviewData()
    }
  },
  methods: {
    getOverviewData() {
      fetchOverview().then(res => {
        if (res.code === serviceConst.resCode.succ) {
          this.overviewData = res.data
        }
      })
    },
    handleSetLineChartData(type) {
      this.$emit('handleSetLineChartData', type)
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  .icon-warning{
      font-size: 15px;
      position: relative;
      top: -4px;
      cursor: pointer;
      color: #FFFFFF;
    }
  .card-panel-col{
    margin-right: 20px;
    .card-panel {
      position: relative;
      box-sizing: border-box;
      padding: 26px 33px 29px;
      box-shadow: 0px 40px 11px 0px rgba(114, 128, 187, 0.00), 0px 26px 10px 0px rgba(114, 128, 187, 0.02), 0px 14px 9px 0px rgba(114, 128, 187, 0.07), 0px 6px 6px 0px rgba(114, 128, 187, 0.12), 0px 2px 4px 0px rgba(114, 128, 187, 0.14);
      border-radius: 8px;
      overflow: hidden;
      .card-panel-text {
        font-weight: 500;  font-family: 'Poppins-Medium';
        font-size: 14px;
        line-height: 1.2;
        margin-bottom:16px;
      }
      .card-panel-num {
        color: #488CE8;
        font-weight: 600;  font-family: 'Poppins-SemiBold';
        font-size: 24px;
        line-height: 1.2;
      }

    }
    &:nth-child(1) .card-panel {
      background: #488CE8;
      .card-panel-text {
        color: #FFFFFF;
      }
      .card-panel-num {
        color: #FFFFFF;
      }
    }
    &:nth-child(2) .card-panel,
    &:nth-child(3) .card-panel
     {
      background: #fff;
      .card-panel-text {
        color: #364250
      }
      .card-panel-num {
        color: #364250;
      }
    }
  }
}

.img-bg{
  width: 116px;
  height: 116px;
  position: absolute;
  right: 0;
  bottom: 0;
}
// @media screen and (max-width: 376px) {
//   .panel-group {
//     .card-panel-col {
//       width: 100%;
//     }
//   }
// }
</style>
